import classNames from 'clsx';
import React, { memo, ReactElement } from 'react';
import { IProduct } from 'reactApp/modules/products/products.types';

import styles from './TrialPromoSidebar.css';
import { useContent } from './useContent';

export const TrialPromoSidebar = memo(({ product }: { product: IProduct }): ReactElement => {
    const { hasTrial } = product ?? {};
    const { header, description, features, footer } = useContent(product);

    return (
        <div
            className={classNames(styles.root, {
                [styles.root_trial]: hasTrial,
            })}
        >
            <div className={styles.tariffInfo}>
                <div className={styles.header}>{header}</div>
                <div className={styles.text}>{description}</div>
                <ol className={styles.features}>
                    {features.map((feature, index) => (
                        <li key={index}>
                            <span className={styles.feature}>{feature}</span>
                        </li>
                    ))}
                </ol>
            </div>
            <div className={styles.paymentInfo}>{footer}</div>
        </div>
    );
});

TrialPromoSidebar.displayName = 'TrialPromoSidebar';
